// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2fa1J","header":"PatientQuestionnaire_header__2__Pn","info":"PatientQuestionnaire_info__1hXH2"};